// extracted by mini-css-extract-plugin
module.exports = {"privacyRoot":"PrivacyPolicy-module--privacyRoot--2_lKG","privacyContainer":"PrivacyPolicy-module--privacyContainer--3oDEJ","center":"PrivacyPolicy-module--center--Mzp2m"};